// components
import AppointmentForm from './AppointmentForm';

// stores
import { useAppointmentStore } from 'components/mrp/stores/appointmentStore/appointmentStore';
import { ShortcutContext } from 'components/shared/ShortcutProvider/ShortcutContext';
import { GLOBAL_CONTEXT } from 'components/shared/ShortcutProvider/ShortcutProvider.consts';

// utils
import { useShallow } from 'zustand/shallow';
import { Activity, useContext, useEffect } from 'react';

const AppointmentFormVisibility = () => {
  const appointment = useAppointmentStore(
    useShallow((state) => state.appointment)
  );

  const { setActiveShortcutContexts, shortcuts } = useContext(ShortcutContext);

  useEffect(() => {
    setActiveShortcutContexts?.(
      !!appointment ? [GLOBAL_CONTEXT] : Object.keys(shortcuts)
    );
  }, [appointment, setActiveShortcutContexts, shortcuts]);

  return (
    <Activity mode={!!appointment ? 'visible' : 'hidden'}>
      <AppointmentForm key={appointment?.id} />
    </Activity>
  );
};

export default AppointmentFormVisibility;
